<template>
  <div>
    <HeaderBar></HeaderBar>
    <Security></Security>
    <!-- <ContactUs id="contact"></ContactUs> -->
    <FooterBar></FooterBar>
  </div>
</template>

<script>

import FooterBar from '../components/site/Footer/Footer'
import HeaderBar from '../components/site/Header/Header'
import ContactUs from '../components/ContactUs'
import Security from '../components/Security'

export default {
  components: {
    HeaderBar,
    Security,
    ContactUs,
    FooterBar
  }
}

</script>



// WEBPACK FOOTER //
// Security.vue?e16a4cb2